var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("kobra-search", {
        ref: "kobrasearch",
        attrs: {
          "search-query": _vm.searchQuery,
          "selected-kobra-info-type": _vm.selectedKobraInfoType,
          "selected-kobra-branch-group": _vm.selectedKobraBranchGroup,
          "selected-kobra-search-type": _vm.selectedKobraSearchType,
          limit: 100,
          "show-iframe": true,
          "show-infotypes": true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }